const data = [
    {
      id: 1,
      image: "https://img.icons8.com/windows/96/graduation-cap.png",
      title: "IT Engineer",
      desc: "Recently graduated as Information Technology Engineer from Yachay Tech University.",
    },
    {
      id: 2,
      image: "https://img.icons8.com/windows/96/developer.png",
      title: "Full-Stack Development",
      desc: " Front End and Back End Systems Developer",
    },
    {
      id: 3,
      image: "https://img.icons8.com/ios/100/python--v1.png",
      title: "Python Developer",
      desc: " Advanced software developer",
    },


  ]
  export default data